module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("his book owes its existence to two Stephens: my late husband the author Stephen Porter, who wrote the text, and his friend Dr Stephen Roberts, who saw the work through to publication. As his health declined, my husband asked Dr Roberts to take on the onerous task of editing and making the manuscript fit for publication. Without a quibble, Stephen Roberts diligently set about his task and enabled this book to see the light of day. I am truly indebted to Stephen Roberts for his persistence and expertise. I am very grateful to everyone at Pen and Sword who made this book possible and for their understanding in dealing with a posthumous publication. Finally, I would like to thank the National Gallery of Art in Washington, the Wellcome Collection and the Yale Center for British Art for making so many of their images freely available.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("Carolyn Porter")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bbbc5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 72
// module chunks = 0